import axios from 'axios';

export const postApi = (apiUrl, header, body)=>{
    // Remove undefined values from headers to avoid sending "Bearer undefined"
    const cleanHeaders = {};
    Object.keys(header).forEach(key => {
        if (header[key] !== undefined && header[key] !== null) {
            cleanHeaders[key] = header[key];
        }
    });
    
    return fetch(apiUrl,{
       method: 'POST',
       headers: cleanHeaders,
       body: JSON.stringify(body)
   }).then(async (res) => {
       // Check if response is ok (status 200-299)
       if (!res.ok) {
           // Try to parse error response
           let errorData;
           try {
               errorData = await res.json();
           } catch (e) {
               errorData = { status: false, msg: `HTTP ${res.status}: ${res.statusText}` };
           }
           // For offline errors (503), include the error data in the rejection
           if (res.status === 503 && errorData.offline) {
               return Promise.reject({
                   status: false,
                   message: errorData.msg || errorData.message || 'You are offline',
                   statusCode: res.status,
                   offline: true,
                   data: errorData.data || []
               });
           }
           // Return error in consistent format
           return Promise.reject({
               status: false,
               message: errorData.msg || errorData.message || errorData.error || `Request failed with status ${res.status}`,
               statusCode: res.status
           });
       }
       const jsonData = await res.json();
       // Check if response has offline flag (cached data)
       if (jsonData.offline || jsonData.cached) {
           jsonData.offline = true;
           jsonData.cached = true;
       }
       return jsonData;
   })
   .catch(e => {
       console.error(`API Error: ${e.message || e}`);
       // If it's already a rejected promise with error object, re-throw it
       if (e.status !== undefined) {
           return Promise.reject(e);
       }
       // Otherwise, wrap in error object
       return Promise.reject({
           status: false,
           message: e.message || 'Network error. Please check your connection and try again.',
           statusCode: 0
       });
   });
}

export const getApi = (apiUrl, header)=>{
    // Remove undefined values from headers to avoid sending "Bearer undefined"
    const cleanHeaders = {};
    Object.keys(header).forEach(key => {
        if (header[key] !== undefined && header[key] !== null) {
            cleanHeaders[key] = header[key];
        }
    });
    
    return fetch(apiUrl,{
       method: 'GET',
       headers: cleanHeaders,
   }).then(async (res) => {
       // Check if response is ok (status 200-299)
       if (!res.ok) {
           // Try to parse error response
           let errorData;
           try {
               errorData = await res.json();
           } catch (e) {
               errorData = { status: false, msg: `HTTP ${res.status}: ${res.statusText}` };
           }
           // For offline errors (503), include the error data in the rejection
           if (res.status === 503 && errorData.offline) {
               return Promise.reject({
                   status: false,
                   message: errorData.msg || errorData.message || 'You are offline',
                   statusCode: res.status,
                   offline: true,
                   data: errorData.data || []
               });
           }
           // Return error in consistent format
           return Promise.reject({
               status: false,
               message: errorData.msg || errorData.message || errorData.error || `Request failed with status ${res.status}`,
               statusCode: res.status
           });
       }
       const jsonData = await res.json();
       // Check if response has offline flag (cached data)
       if (jsonData.offline || jsonData.cached) {
           jsonData.offline = true;
           jsonData.cached = true;
       }
       return jsonData;
   })
   .catch(e => {
       console.error(`API Error: ${e.message || e}`);
       // If it's already a rejected promise with error object, re-throw it
       if (e.status !== undefined) {
           return Promise.reject(e);
       }
       // Otherwise, wrap in error object
       return Promise.reject({
           status: false,
           message: e.message || 'Network error. Please check your connection and try again.',
           statusCode: 0
       });
   });
}

export const uploadFile = (apiUrl, header, data)=>{
    return axios
    .post(apiUrl, data, {
      headers: header
    })
    .then((res)=>res)
       .catch(e=>console.log(`Error: ${e}`))
}

// All functions are now exported using ES6 export syntax above


// WEBPACK FOOTER //
// ./src/service/service.js